import { ApolloLink } from '@apollo/client';

type RedirectErrors = 'email_not_verified' | 'unknown_user' | 'access_denied';

export type onAuthErrorRedirectLinkOptions = {
  emailNotVerifiedRedirectPath?: string;
  unknownUserRedirectPath?: string;
  accessDeniedPath?: string;
};

export function onAuthErrorRedirectLink(
  options?: onAuthErrorRedirectLinkOptions
): ApolloLink {
  const {
    emailNotVerifiedRedirectPath = '/email-not-verified',
    unknownUserRedirectPath = '/unknown-user',
    accessDeniedPath = '/?error=access_denied'
  } = options ?? {};

  const errorRedirectMap: Record<
    RedirectErrors,
    { path: string; code: string }
  > = {
    access_denied: {
      path: accessDeniedPath,
      code: 'FORBIDDEN'
    },
    email_not_verified: {
      path: emailNotVerifiedRedirectPath,
      code: 'FORBIDDEN'
    },
    unknown_user: { path: unknownUserRedirectPath, code: 'FORBIDDEN' }
  };

  return new ApolloLink((operation, forward) => {
    return forward(operation).map((response) => {
      if (response.errors) {
        for (const error of response.errors) {
          if (error.message in errorRedirectMap) {
            const redirectInfo =
              errorRedirectMap[error.message as RedirectErrors];
            if (
              redirectInfo &&
              error.extensions?.code === redirectInfo.code &&
              !window.location.href.includes(redirectInfo.path)
            ) {
              window.location.href = redirectInfo.path;
              break;
            }
          }
        }
      }
      return response;
    });
  });
}
